import fetchLayers from "./fetchLayers";

const surveyJs = {
    fetchLayers
};

export default surveyJs;
